import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const fetchAllBus = createAsyncThunk(
  "Buss/fetchAllBus",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const res = await axios.get(`${BaseUrl}/getAllBus`, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      const result = await res.data.data;
      return result;
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);

export const fetchBusBYId = createAsyncThunk(
  "Buss/fetchBusBYId",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const res = await axios.get(`${BaseUrl}/getBus/${id}`, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      const result = await res.data.data;

      return result;
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);

export const insertBus = createAsyncThunk(
  "Buss/insertBus",
  async (values, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      await axios.post(`${BaseUrl}/addBus`, values, {       headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, });
      sweetalert({
        text: "تم الإضافة بنجاح",
        icon: "success",
        buttons: {
          confirm: {
            text: "تم",
            className: "custom-button-class",
          },
        },
        className: "alert-div",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      // Check if the error status code is 403 Forbidden or another status code
      if (error.response && error.response.status === 403) {
        // Handle the 403 Forbidden error specifically
        sweetalert({
          text: "ليس لديك صلاحية للقيام بهذا",
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      }
      else if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      }  
      else {
        // Handle other errors with a generic message
        const errorMessage =
          error.response?.data?.message || error.response?.data?.data ;
        sweetalert({
          text: errorMessage,
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      }
      return rejectWithValue(error.message);
    }
  }
);

export const updateBus = createAsyncThunk(
  "Buss/updateBus",
  async (values, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      await axios.post(`${BaseUrl}/updateBus/${values.id}`, values, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      sweetalert({
        text: "تم التعديل بنجاح",
        icon: "success",
        buttons: {
          confirm: {
            text: "تم",
            className: "custom-button-class",
          },
        },
        className: "alert-div",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      // Check if the error status code is 403 Forbidden or another status code
      if (error.response && error.response.status === 403) {
        // Handle the 403 Forbidden error specifically
        sweetalert({
          text: "ليس لديك صلاحية للقيام بهذا",
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      } 
      else if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      else {
        // Handle other errors with a generic message
        const errorMessage =
          error.response?.data?.message || error.response?.data?.data;
        sweetalert({
          text: errorMessage,
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      }
      return rejectWithValue(error.message);
    }
  }
);

export const deleteBus = createAsyncThunk(
  "Buss/deleteBus",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      await axios.delete(`${BaseUrl}/hardDeleteBus/${id}`, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      sweetalert({
        text: "تم الحذف بنجاح",
        icon: "success",
        buttons: {
          confirm: {
            text: "تم",
            className: "custom-button-class",
          },
        },
        className: "alert-div",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      // Check if the error status code is 403 Forbidden or another status code
      if (error.response && error.response.status === 403) {
        // Handle the 403 Forbidden error specifically
        sweetalert({
          text: "ليس لديك صلاحية للقيام بهذا",
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      }
      else if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      else {
        // Handle other errors with a generic message
        const errorMessage =
          error.response?.data?.message || error.response?.data?.data;
        sweetalert({
          text: errorMessage,
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      }
      return rejectWithValue(error.message);
    }
  }
);

const BusSlice = createSlice({
  name: "Buss",
  initialState: {
    Buss: [],
    BusID: [],
    InsertBus: [],
    UpdateBus: [],
    loading: false,
    loadingupdate: false,
    loadingdelete: false,
    error: null,
  },
  reducers: {
    clearBus: (state) => {
      state.Buss = [];
      state.BusID = [];
      state.InsertBus = [];
      state.UpdateBus = [];
      state.loading = false;
      state.loadingupdate = false;
      state.loadingdelete = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loadingupdate = action.payload; // Set isLoading to the provided value 
      state.loadingdelete = action.payload; // Set isLoading to the provided value 
    },
  },
  extraReducers: {
    //fetch All Bus
    [fetchAllBus.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fetchAllBus.fulfilled]: (state, action) => {
      state.Buss = action.payload;
      state.loading = false;
    },
    [fetchAllBus.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    //Fetch Bus By ID
    [fetchBusBYId.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fetchBusBYId.fulfilled]: (state, action) => {
      state.BusID = action.payload;
      state.loading = false;
    },
    [fetchBusBYId.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    //insert  Bus
    [insertBus.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [insertBus.fulfilled]: (state, action) => {
      state.InsertBus.push(action.payload);
      state.loading = false;
    },
    [insertBus.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    //Update  Bus
    [updateBus.pending]: (state, action) => {
      state.loadingupdate = true;
      state.error = null;
    },
    [updateBus.fulfilled]: (state, action) => {
      state.UpdateBus.push(action.payload);
      state.loadingupdate = false;
    },
    [updateBus.rejected]: (state, action) => {
      state.error = action.payload;
      state.loadingupdate = false;
    },
    //delete Bus
    [deleteBus.pending]: (state, action) => {
      state.loadingdelete = true;
      state.error = null;
    },
    [deleteBus.fulfilled]: (state, action) => {
      state.Buss = state.Buss.filter((el) => el.id !== action.payload.id);
      state.loadingdelete = false;
    },

    [deleteBus.rejected]: (state, action) => {
      state.error = action.payload;
      state.loadingdelete = false;
    },
  },
});
export const { clearBus ,setLoading} = BusSlice.actions;

export default BusSlice.reducer;
